var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"com-container"}},[_c(_vm.dataAnalysis,{tag:"component"}),_c(_vm.leftType,{tag:"component"}),_c(_vm.rightType,{tag:"component",attrs:{"rightProps":_vm.rightProps},on:{"runInHole":_vm.rightTypeClick,"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }